import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Loader } from "./components/Loader";
import { ScrollToTop } from "./components/ScrollToTop";
import { CookieBanner } from "./components/CookieBanner";
import { Analytics } from "./components/Analytics";
import { Home } from "./pages/Home";
import { Services } from "./pages/Services";
import { Airbnb } from "./pages/Airbnb";
import { Zones } from "./pages/Zones";
import { APropos } from "./pages/APropos";
import { Contact } from "./pages/Contact";
import { Confidentialite } from "./pages/Confidentialite";
import { MentionsLegales } from "./pages/MentionsLegales";
import { NotFound } from "./pages/NotFound";

const ease = [0.22, 1, 0.36, 1] as const;

export default function App() {
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (loaded) {
      const t = window.setTimeout(() => {
        document.querySelector<HTMLElement>("main")?.focus({ preventScroll: true });
      }, 50);
      return () => window.clearTimeout(t);
    }
  }, [loaded]);

  return (
    <>
      <AnimatePresence>
        {!loaded && <Loader key="loader" onDone={() => setLoaded(true)} />}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: loaded ? 1 : 0 }}
        transition={{ duration: 0.5 }}
        aria-hidden={!loaded}
      >
        <ScrollToTop />
        <Analytics />
        <Navbar />
        <main
          id="contenu"
          tabIndex={-1}
          className="pt-28 focus:outline-none overflow-x-hidden"
        >
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.35, ease }}
            >
              <Routes location={location}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/nettoyage-airbnb" element={<Airbnb />} />
                <Route path="/zones-intervention" element={<Zones />} />
                <Route path="/a-propos" element={<APropos />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/politique-de-confidentialite" element={<Confidentialite />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </motion.div>
          </AnimatePresence>
        </main>
        <Footer />
        <CookieBanner />
      </motion.div>
    </>
  );
}
